module.exports = __webpack_public_path__ + "static/media/close.4001cba6.svg";